var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.show ? _c("w-progress-circular") : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }